import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/components/ui/form';
import { UploadTerminImage } from '@/domain/termine/components/TerminImage/UploadTerminImage';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';

export function ImageFormField() {
  const { form } = useCreateTermineFormContext();

  return (
    <FormField
      control={form.control}
      name="terminBild"
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <UploadTerminImage
              image={field.value}
              variant="sheet"
              markierung={form.getValues('markierung')}
              className="text-neutrals-700"
              onFileSelect={(file) => {
                field.onChange(
                  file
                    ? { file, name: file.name, contentType: file.type }
                    : null,
                );
                form.trigger('terminBild');
              }}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}></FormField>
  );
}
